import React from "react";
import { motion } from "framer-motion";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaMountain, FaArrowRight } from "react-icons/fa"; // Icons import

import Navr from "../Navbar/Navr";
import Footer from "../Components2/Footer";

// Images Import
import heroImg from "../Ecomphotos/kash.jpg"; // Main Hero Image (using kash.jpg as base)
import shimlaImg from "../Ecomphotos/shimla.jpg";
import manaliImg from "../Ecomphotos/manali.jpg";
import kasolImg from "../Ecomphotos/kasol.jpg";
import dalhousieImg from "../Ecomphotos/dal.jpg";

export default function Himachal() {
  // Destination Data (Clean Code Strategy)
  const destinations = [
    { id: 1, name: "Shimla", img: shimlaImg, desc: "Queen of Hills" },
    { id: 2, name: "Manali", img: manaliImg, desc: "Adventure Hub" },
    { id: 3, name: "Kasol", img: kasolImg, desc: "Mini Israel" },
    { id: 4, name: "Dalhousie", img: dalhousieImg, desc: "Little Switzerland" },
  ];

  return (
    <div className="himachal-page-wrapper">
      <Navr />

      {/* --- Section 1: Hero Banner (Parallax Effect) --- */}
      <div
        className="himachal-hero d-flex align-items-center justify-content-center"
        style={{ backgroundImage: `url(${heroImg})` }}
      >
        <div className="hero-overlay"></div>
        <Container className="text-center position-relative z-2">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            <h5 className="text-white-50 text-uppercase ls-2 mb-3">
              Escape to the Himalayas
            </h5>
            <h1 className="display-2 fw-bold text-white mb-4 text-shadow">
              Himachal Tour Packages
            </h1>
            <p
              className="text-white lead mx-auto"
              style={{ maxWidth: "700px" }}
            >
              Discover snow-capped peaks, lush valleys, and serene rivers with
              Jawali Holidays.
            </p>
          </motion.div>
        </Container>
      </div>

      {/* --- Section 2: Introduction --- */}
      <section className="py-5 bg-white">
        <Container>
          <Row className="align-items-center my-5">
            <Col lg={7} className="mb-4 mb-lg-0">
              <h6 className="text-primary fw-bold text-uppercase ls-1">
                Discover Nature
              </h6>
              <h2 className="mb-4 fw-bold text-dark display-6">
                The Abode of Snow Awaits
              </h2>

              <p className="text-muted lead-sm text-justify">
                Escape to the breathtaking hills of Himachal Pradesh with our
                all-inclusive tour package. Explore the serene beauty of Shimla,
                the adventure thrills of Manali, and the spiritual charm of
                Dharamshala. Surrounded by snow-capped peaks, lush valleys, and
                peaceful rivers, Himachal is a paradise for nature and adventure
                lovers alike.
              </p>
              <p className="text-muted lead-sm text-justify">
                Enjoy paragliding in Solang Valley, stroll through apple
                orchards, and experience the cozy mountain lifestyle. Our
                Himachal tour offers comfortable stays, scenic road trips, and
                unforgettable sightseeing experiences. Book your Himachal tour
                today and discover the magic of the Himalayas — where every
                moment feels like a dream come true.
              </p>

              <Link
                to="/contact"
                className="btn btn-outline-primary rounded-pill px-4 py-2 mt-3 fw-bold"
              >
                Plan Your Journey <FaArrowRight className="ms-2" />
              </Link>
            </Col>

            <Col lg={5}>
              <div className="image-stack">
                {/* Using the main image again here, but stylized */}
                <img
                  src={heroImg}
                  className="img-fluid rounded-4 shadow-lg main-intro-img"
                  alt="Himachal Beauty"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* --- Section 3: Destinations Grid --- */}
      <section className="py-5 bg-light section-destinations">
        <Container>
          <div className="text-center mb-5">
            <h6 className="text-primary fw-bold text-uppercase ls-1">
              Popular Destinations
            </h6>
            <h2 className="fw-bold display-6">Explore Himachal with Us</h2>
            <div className="heading-underline mx-auto"></div>
          </div>

          <Row className="g-4">
            {destinations.map((place) => (
              <Col md={6} lg={3} key={place.id}>
                <div className="dest-card h-100">
                  <div className="dest-img-box">
                    <img
                      src={place.img}
                      alt={place.name}
                      className="img-fluid"
                      loading="lazy"
                    />
                    <div className="dest-overlay"></div>
                  </div>
                  <div className="dest-content p-4 text-center">
                    <FaMountain className="text-primary mb-3 fs-4" />
                    <h4 className="fw-bold mb-1">{place.name}</h4>
                    <span className="text-muted small fst-italic">
                      {place.desc}
                    </span>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* --- Section 4: Final Call to Action Banner --- */}
      <section className="py-5 cta-banner text-center text-white">
        <Container>
          <h2 className="fw-bold mb-4">
            Mountains are Calling, and You Must Go!
          </h2>
          <p className="lead mb-5 text-white-50">
            Don't wait any longer. Let us customize the perfect Himalayan
            getaway for you.
          </p>
          <Link
            to="/Contact"
            className="btn btn-light text-primary btn-lg rounded-pill px-5 fw-bold shadow-sm hover-lift"
          >
            Book Your Trip Now
          </Link>
        </Container>
      </section>

      <Footer />
    </div>
  );
}
